export default import.meta.ROLLDOWN_FILE_URL_yG0Opi_V9aYPvWSzqGTDmw